module.exports = __webpack_public_path__ + "image/share-icon5.png";